import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import AdvertBanner from "@/components/AdvertBanner";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";

const CookiesPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFBFC]" data-testid="cookies-page">
      <Navbar />
      <div className="pt-28 pb-16 px-4">
        <AdvertBanner />
        <article className="max-w-3xl mx-auto">
          <Button variant="ghost" className="mb-6 text-gray-500" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-4 w-4 mr-2" /> Back
          </Button>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Cookie Policy</h1>
          <p className="text-sm text-gray-500 mb-8">Last updated: April 2026</p>

          <div className="prose max-w-none text-gray-700 space-y-6">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. What Are Cookies?</h2>
              <p className="leading-relaxed">Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work efficiently, provide a better user experience, and supply information to website operators. Cookies help us remember your preferences, keep you signed in, and understand how you interact with our Service.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. Types of Cookies We Use</h2>

              <h3 className="text-lg font-semibold text-gray-800 mt-5 mb-2">Essential Cookies</h3>
              <p className="leading-relaxed">These cookies are necessary for the website to function properly. They enable core features such as admin authentication, session management, and security. Without these cookies, the Service cannot operate correctly. These cookies do not collect personal information for marketing purposes.</p>

              <h3 className="text-lg font-semibold text-gray-800 mt-5 mb-2">Preference Cookies</h3>
              <p className="leading-relaxed">These cookies remember your choices and preferences, such as your selected language, timezone, and country/currency settings. They allow us to provide you with a personalized experience and avoid asking you to re-enter your preferences each time you visit.</p>

              <h3 className="text-lg font-semibold text-gray-800 mt-5 mb-2">Functional Cookies</h3>
              <p className="leading-relaxed">These cookies help us track whether you have seen our welcome message, ensuring it only appears once per day. They also help manage the one-time view code expiry timer and other interactive features on the site.</p>

              <h3 className="text-lg font-semibold text-gray-800 mt-5 mb-2">Analytics Cookies</h3>
              <p className="leading-relaxed">We may use analytics cookies to understand how visitors interact with our website. This information is used to compile reports and help us improve the site. These cookies collect information in an anonymous form, including the number of visitors, where visitors have come from, and the pages they visited.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. How to Manage Cookies</h2>
              <p className="leading-relaxed">Most web browsers allow you to control cookies through their settings. You can typically find these settings in the "Options" or "Preferences" menu of your browser. You can set your browser to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Accept all cookies</li>
                <li>Notify you when a cookie is set</li>
                <li>Reject all cookies</li>
                <li>Delete cookies that have already been set</li>
              </ul>
              <p className="leading-relaxed mt-3">Please note that disabling or deleting cookies may impact the functionality of certain features on our website, particularly session management and preference storage.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. Third-Party Cookies</h2>
              <p className="leading-relaxed">We do not use third-party advertising cookies. However, some third-party services we integrate with (such as payment processors) may set their own cookies when you interact with their services through our website. We have no control over these third-party cookies. Please refer to the respective third party's cookie policy for more information.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. Local Storage</h2>
              <p className="leading-relaxed">In addition to cookies, we may use browser local storage to store your language and timezone preferences, and to manage the frequency of welcome messages. Local storage functions similarly to cookies but can store larger amounts of data and is not sent to the server with every request.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. Updates to This Policy</h2>
              <p className="leading-relaxed">We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our data practices. Any changes will be posted on this page with an updated revision date.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">7. Contact Us</h2>
              <p className="leading-relaxed">If you have any questions about our use of cookies, please contact us via text at +1 (208) 315-6308 or submit a support ticket through our website.</p>
            </section>
          </div>
        </article>
      </div>
      <Footer />
    </div>
  );
};

export default CookiesPage;
